import { useQuery, useQueryClient } from "react-query";
import { JobHttpService } from "../service";

/**
 * A custom React hook for fetching and paginating explore posts.
 * @returns {{
 *   data: any,
 *   isLoading: boolean,
 *   isError: boolean,
 * }}
 */
function UseCandidatesList({size = 30, filters = {}}) {
    const queryClient = useQueryClient();

    const {
        data,
        isLoading,
        isError,
    } = useQuery(
        ["candidates_list", size, filters],
        () => {
            return JobHttpService.loadCandidates({size: size, filters: filters})
        },
        {
            onSuccess: (data) => {
                // console.log(data);
            },
            onError: (error) => {
                // Silently handle errors for public access
                console.warn('Error loading candidates:', error);
            },
            keepPreviousData: true,
            staleTime: 30000,
            retry: false  // Don't retry on error for public access
        }
    );

    const removeItemFromList = (candidateId) => {
        queryClient.setQueryData(["candidates_list", size, filters], oldData => ({
            ...oldData,
            results: oldData.results.filter(candidate => candidate.id !== candidateId)
        }));
    };

    return { data, isLoading, isError, removeItemFromList };
}

export default UseCandidatesList;